import { render, staticRenderFns } from "./ResumenPlazos.vue?vue&type=template&id=f6dab0d0"
import script from "./ResumenPlazos.vue?vue&type=script&lang=js"
export * from "./ResumenPlazos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports